var _path, _path2, _path3, _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcSocRevenueOnMonth(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 42,
    viewBox: "0 0 42 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.375 21C4.375 13.1629 4.375 9.24435 6.80967 6.80967C9.24435 4.375 13.1629 4.375 21 4.375C28.8371 4.375 32.7557 4.375 35.1903 6.80967C37.625 9.24435 37.625 13.1629 37.625 21C37.625 28.8371 37.625 32.7557 35.1903 35.1903C32.7557 37.625 28.8371 37.625 21 37.625C13.1629 37.625 9.24435 37.625 6.80967 35.1903C4.375 32.7557 4.375 28.8371 4.375 21Z",
    fill: "#03A3E8",
    fillOpacity: 0.1
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0034 21V19.75C20.2812 19.75 19.6755 19.5289 19.2785 19.2312C18.882 18.9337 18.7534 18.6182 18.7534 18.375H17.5034H16.2534C16.2534 19.5815 16.9084 20.5785 17.7785 21.2312C18.6483 21.8835 19.7926 22.25 21.0034 22.25V21ZM17.5034 18.375H18.7534C18.7534 18.1318 18.882 17.8163 19.2785 17.5188C19.6755 17.2211 20.2812 17 21.0034 17V15.75V14.5C19.7926 14.5 18.6483 14.8665 17.7785 15.5188C16.9084 16.1715 16.2534 17.1685 16.2534 18.375H17.5034ZM24.5034 23.625H23.2534C23.2534 23.8682 23.1249 24.1837 22.7283 24.4812C22.3313 24.7789 21.7256 25 21.0034 25V26.25V27.5C22.2142 27.5 23.3585 27.1335 24.2283 26.4812C25.0984 25.8285 25.7534 24.8315 25.7534 23.625H24.5034ZM21.0034 21V22.25C21.7256 22.25 22.3313 22.4711 22.7283 22.7688C23.1249 23.0663 23.2534 23.3818 23.2534 23.625H24.5034H25.7534C25.7534 22.4185 25.0984 21.4215 24.2283 20.7688C23.3585 20.1165 22.2142 19.75 21.0034 19.75V21ZM21.0034 15.75V17C22.19 17 22.9553 17.5697 23.1735 18.0329L24.3043 17.5L25.435 16.9671C24.6923 15.3912 22.8647 14.5 21.0034 14.5V15.75ZM21.0034 26.25V25C19.8169 25 19.0516 24.4303 18.8333 23.9671L17.7026 24.5L16.5718 25.0329C17.3145 26.6088 19.1421 27.5 21.0034 27.5V26.25ZM21.0034 15.75H22.2534V14H21.0034H19.7534V15.75H21.0034ZM21.0034 26.25H19.7534V28H21.0034H22.2534V26.25H21.0034Z",
    fill: "#87FF0B"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.75 37.625C22.75 37.625 22.1968 37.625 21 37.625C13.1629 37.625 9.24435 37.625 6.80967 35.1903C4.375 32.7557 4.375 28.8371 4.375 21C4.375 13.1629 4.375 9.24437 6.80967 6.80969C9.24435 4.37502 13.1629 4.37502 21 4.37502C28.8371 4.37502 32.7556 4.37502 35.1903 6.80969C37.625 9.24437 37.625 13.1629 37.625 21C37.625 22.1968 37.625 22.75 37.625 22.75",
    stroke: "#1EF5DF",
    strokeWidth: 2.5,
    strokeLinecap: "round"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_12724_590)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.5333 27.0667V28.4667M30.7999 27.0667V28.4667",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M28.0388 30.4889H37.2944",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.4944 32.7991C27.4944 30.4268 27.4944 29.2407 28.1761 28.5037C28.8578 27.7667 29.955 27.7667 32.1494 27.7667H33.1838C35.3782 27.7667 36.4754 27.7667 37.1571 28.5037C37.8388 29.2407 37.8388 30.4268 37.8388 32.7991V33.0787C37.8388 35.451 37.8388 36.6372 37.1571 37.3742C36.4754 38.1111 35.3782 38.1111 33.1838 38.1111H32.1494C29.955 38.1111 28.8578 38.1111 28.1761 37.3742C27.4944 36.6372 27.4944 35.451 27.4944 33.0787V32.7991Z",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M27.7666 30.4889H37.5666",
    stroke: "#1EF5DF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 33H36",
    stroke: "#1EF5DF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 35H33",
    stroke: "#1EF5DF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12724_590"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13.0667,
    height: 14,
    fill: "white",
    transform: "translate(26.1333 25.2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcSocRevenueOnMonth);
export default __webpack_public_path__ + "static/media/ic_soc_revenue_on_month.b1d418b518c3722e71d0b3c6b666168d.svg";
export { ForwardRef as ReactComponent };